import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router";
import styled from "styled-components";
import "../../../assets/css/components/CheckboxDark.css";
import { defaultStatusColors } from "../../../utils/CardUtils";

// #region Styled Components
const CustomNestedCols = styled.tr`
    & {
        display: flex;
        align-items: stretch;
        width: 100%;
        box-sizing: border-box;
        font-size: 12px !important;
        font-weight: 400;
        font-family: Roboto;
        border-bottom: 1px solid #333f50 !important;
        min-height: 42px;
        border-bottom: none !important;
    }

    .Icon {
        width: 10px;
        height: 10px;
        font-size: 9px;
        font-weight: 500;
        color: var(--text-icons-gray-200);
        position: relative;
        top: 0px;
    }

    td {
        min-height: 42px;
        line-height: 30px;

        //one line ellipsis
    }
    td > span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &.nested-row-tr-header > td {
        color: var(--text-icons-gray-200, #7c868b) !important;
        font-size: 11px !important;
    }

    button.three-btn-class {
        width: calc(100% / 3 - 8px / 3);
        text-overflow: ellipsis;
        overflow: hidden;
        align-items: center;
    }

    .td-bottom-border {
        border-bottom: 1px solid #333f50 !important;
    }

    .nested-col-first {
        width: 35px;
        flex: 0 0 35px;
        min-width: 35px;
        margin: 0px;
        opacity: 0;
    }

    .nested-col-last {
    }

    .nested-col-default {
        padding-left: 8px;
        padding-right: 0px;
        background: var(--backgrounds-lines-n-500, #141922);

        -webkit-box-flex: 1;
        flex: 1 0 0px;
        max-width: 100%;
        min-width: 100px;

        position: relative;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        box-sizing: border-box;
    }
`;

export const CustomButton = styled.button`
    & {
        display: flex;
        padding: 8px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        width: auto;
        height: 25px;

        border-radius: 4px;
        border: 1px solid var(--backgrounds-lines-n-200, #262e3e);
        background-color: transparent;

        color: var(--text-icons-gray-100, #d1d1d1);

        /* Subtitle 3 */
        font-family: Roboto;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 7px;
    }

    &.disabled {
        color: var(--text-icons-gray-300, #4f5b6d);
    }
`;

export const FloatingDiv = styled.div`
    & {
        display: flex;
        padding: 0px 3px;
        flex-direction: column;
        align-items: flex-end;
        gap: 10px;
        width: fit-content;

        border-radius: 2px;
        background: var(--Buttons-All-Platforms-btn-action-green, #080);

        color: var(--text-icons-gray-100, #d1d1d1);
        font-family: Roboto;
        font-size: 8px !important;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;

export const CustomExpandedRow = styled.table`
    & {
        width: 100%;
        max-width: 100%;
        margin-bottom: 0px;
        background: var(--backgrounds-lines-n-500, #141922);
        border-radius: 4px;
    }
`;
// #endregion

export default function FFCsCustomExpandedComponent(props) {
    // #region VARS
    const { data, handleOnAcceptClick, handleOnSuspendClick, handleOnRemoveClick } = props;
    const navigate = useNavigate();
    const expandedRowName = "connectedBrands";
    const expandedRows = data?.[expandedRowName] || [];

    // #endregion

    // #region METHODS
    /*const mapStatusText = row => {
        if (row?.parentStoreStatus !== "Active") return "Not connected";
        else if (row?.status === "Active") return "Fulfilling";
        else return row?.status || "Not active";
    }; // This function maps the status text based on the row data*/

    const translateStatus = row => {
        const newRow = { ...row };
        // newRow.status = mapStatusText(row);

        return getStatusColumn(newRow, "status", defaultStatusColors, "Unknown", row);
    }; // This function translates directly the status of the row with the default status colors

    const getSpanWithColor = (text, color) => {
        return <span className={color}>{text}</span>;
    };

    const getStatusColumn = (
        row,
        includeStatusWithArrayFields,
        statusColors,
        defaultNotFound = "Unknown",
        originalRow
    ) => {
        let statusValue = "";
        if (!row) row = {};

        if (typeof row === "object") {
            statusValue = row?.status || defaultNotFound;
        } else if (Array.isArray(row)) {
            statusValue = getArrayFieldValue(row, includeStatusWithArrayFields) || defaultNotFound;
        }

        let colorValue = "text-gray-200";
        let found = false;

        for (const color of statusColors) {
            for (const value of color.forValues) {
                if (value.toLowerCase() === statusValue.toLowerCase()) {
                    found = true;
                    colorValue = color.colorClass;
                    break;
                }
            }
            if (found) break;
        }

        const disconnectReason = `Disconnected due to: ${
            originalRow?.connectedBrands?.fulfillmentCenterCurrentStatus?.statusChangeReason || "Unknown reason"
        }`;
        const removedReason = `Removed due to: ${
            originalRow?.connectedBrands?.fulfillmentCenterCurrentStatus?.statusChangeReason || "Unknown reason"
        }`;
        const tooltipTitle =
            statusValue === "Disconnected" ? disconnectReason : statusValue === "Removed" ? removedReason : "";

        return (
            <div>
                <div className="flex align-items-center">
                    <div className={`status-dot bg-${colorValue}`}></div>
                    <span className={colorValue}>{statusValue}</span>

                    {(statusValue === "Disconnected" || statusValue === "Removed") && (
                        <Tooltip
                            title={tooltipTitle}
                            color="#10141b"
                            overlayInnerStyle={{ textAlign: "center" }}
                            overlayStyle={{ fontSize: "0.75rem", maxWidth: "200px", textAlign: "center" }}>
                            <i className={"Icon fas fa-info-circle ml-5px"} aria-hidden="true"></i>
                        </Tooltip>
                    )}
                </div>
            </div>
        );
    };

    const getArrayFieldValue = (row, array) => {
        if (!Array.isArray(array)) return "Unknown";

        let res = row;
        for (let i = 0; i < array.length; i++) {
            res = res?.[array[i]];
        }
        return res;
    };
    // #endregion

    // #region COLUMNS
    const expandedRowsColumns = [
        {
            name: "Label brand",
            selector: row => (
                <div className="flex align-items-center">
                    <FloatingDiv>New</FloatingDiv>
                    <span style={{ marginLeft: "5px" }}>{row?.labelBrandName ?? "--"}</span>
                </div>
            ),
            minWidth: "14.5%",
            maxWidth: "14.5%"
            // 235px / 1620px = 14.5%
        },
        {
            name: "Country",
            selector: row => row?.labelBrandCountryValue || "--",
            minWidth: "10.8%",
            maxWidth: "10.8%"
        },
        {
            name: "Invitations available",
            selector: row => (
                <InvitationsAvailableColumn
                    row={row}
                    isRequestMoreEnabled={isRequestMoreEnabled}
                    isCheckStockEnabled={isCheckStockEnabled}
                    handleClickRequestMore={handleClickRequestMore}
                    handleClickCheckStock={handleClickCheckStock}
                    getSpanWithColor={getSpanWithColor}
                />
            ),
            minWidth: "260px",
            maxWidth: "18.5%"
        },
        {
            name: "Status",
            selector: row => translateStatus(row),
            hideTitleTooltip: true,
            minWidth: "9.4%",
            maxWidth: "9.4%"
        },
        {
            name: "Actions",
            hideHeaderName: true,
            selector: _ => "Actions",
            minWidth: "14.75%",
            maxWidth: "14.75%"
        }
    ];

    const getColumnIndices = () => {
        const columnLabelBrand = 0,
            columnCountry = 1,
            columnInvitationsAvailable = 2,
            columnStatus = 3,
            columnActions = 4;

        return {
            columnLabelBrand,
            columnCountry,
            columnInvitationsAvailable,
            columnStatus,
            columnActions
        };
    };
    // #endregion

    // #region COMPUTED
    const isActivateEnabled = row => {
        if (row?.parentStoreStatus !== "Active") return false;
        if (row?.invitationsAvailable <= 0) return false;
        if (row?.status === "Fulfilling") return false;
        if (row?.status === "Suspended") return true;
        if (row?.status === "Disconnected") return false;
        if (row?.status === "Removed") return true;
        if (row?.status === "Not active") return true;
        return false;
    };

    const isSuspendEnabled = row => {
        if (row?.parentStoreStatus !== "Active") return false;
        if (row?.status === "Fulfilling") return true;
        if (row?.status === "Suspended") return false;
        if (row?.status === "Disconnected") return false;
        if (row?.status === "Removed") return false;
        if (row?.status === "Not active") return false;
        return false;
    };

    const isRemoveEnabled = row => {
        if (row?.parentStoreStatus !== "Active") return false;
        if (row?.status === "Fulfilling") return true;
        if (row?.status === "Suspended") return true;
        if (row?.status === "Disconnected") return false;
        if (row?.status === "Removed") return false;
        if (row?.status === "Not active") return false;
        return false;
    };

    const isRequestMoreEnabled = row => {
        return false;
    };

    const isCheckStockEnabled = row => {
        if (row?.parentStoreStatus !== "Active") return false;
        return row?.status === "Fulfilling";
    };

    const handleClickActivate = row => {
        if (!isActivateEnabled(row)) return;

        if (handleOnAcceptClick) {
            handleOnAcceptClick(row, true);
        }
    };

    const handleClickSuspend = row => {
        if (!isSuspendEnabled(row)) return;

        if (handleOnSuspendClick) {
            handleOnSuspendClick(row, true);
        }
    };

    const handleClickRemove = row => {
        if (!isRemoveEnabled(row)) return;

        handleOnRemoveClick(row, true);
    };

    const handleClickRequestMore = row => {
        if (!isRequestMoreEnabled(row)) return;
    };

    const handleClickCheckStock = row => {
        if (!isCheckStockEnabled(row)) return;
        navigate("/products/stock?storeID=" + row?.parentID + "&storeName=" + row?.parentName);
    };

    // #endregion

    // #region RENDER
    return (
        <CustomExpandedRow className="CustomExpandedRow">
            <tbody>
                <ExpandedComponentHeaders expandedRowsColumns={expandedRowsColumns} />

                {expandedRows?.length === 0 && <NoDataAvailable expandedRowsColumns={expandedRowsColumns} />}

                {expandedRows?.map((row, index) => (
                    <ExpandedComponentLine
                        key={index}
                        row={row}
                        expandedRowsColumns={expandedRowsColumns}
                        getColumnIndices={getColumnIndices}
                        isAffiliateEnabled={isActivateEnabled}
                        isSuspendEnabled={isSuspendEnabled}
                        isRemoveEnabled={isRemoveEnabled}
                        handleClickAffiliate={handleClickActivate}
                        handleClickSuspend={handleClickSuspend}
                        handleClickRemove={handleClickRemove}
                    />
                ))}
            </tbody>
        </CustomExpandedRow>
    );
    // #endregion
}

// #region SMALL COMPONENTS

const NoDataAvailable = ({ expandedRowsColumns }) => {
    return (
        <CustomNestedCols className="nested-row-tr">
            <td
                className="nested-col-default"
                key="nested-col-1"
                style={{ minWidth: "17.7%", maxWidth: "17.7%", paddingLeft: "0" }}></td>

            <td className="nested-col-default">No data available</td>
            {Array.from({ length: expandedRowsColumns.length - 1 }).map((_, index) => (
                <td className="nested-col-default" key={index}></td>
            ))}

            <td
                className="nested-col-default"
                key="nested-col-action"
                style={{ minWidth: "13.33%", maxWidth: "13.33%" }}></td>
        </CustomNestedCols>
    );
};

const ExpandedComponentHeaders = ({ expandedRowsColumns }) => {
    return (
        <CustomNestedCols className="nested-row-tr-header">
            <td
                className="nested-col-default td-bottom-border"
                key="nested-col-1"
                style={{ minWidth: "17.7%", maxWidth: "17.7%", paddingLeft: "0" }}></td>

            {expandedRowsColumns?.map((col, index) => {
                const spanTitle = col?.hideTitleTooltipHeader || typeof col?.name !== "string" ? "" : col?.name;

                return (
                    <td
                        className="nested-col-default td-bottom-border"
                        key={index}
                        style={{ minWidth: col?.minWidth, maxWidth: col?.maxWidth }}>
                        {col?.hideHeaderName ? null : <span title={spanTitle}>{col?.name}</span>}
                    </td>
                );
            })}

            <td
                className="nested-col-default td-bottom-border"
                key="nested-col-action"
                style={{ minWidth: "13.33%", maxWidth: "13.33%" }}></td>
        </CustomNestedCols>
    );
};

const ExpandedComponentLine = ({
    row,
    getColumnIndices,
    expandedRowsColumns,
    isAffiliateEnabled,
    isSuspendEnabled,
    isRemoveEnabled,
    handleClickAffiliate,
    handleClickSuspend,
    handleClickRemove
}) => {
    const { columnActions } = getColumnIndices(); // Column indices for easier reference

    return (
        <CustomNestedCols className="nested-row-tr">
            <td
                className="nested-col-default"
                key="nested-col-1"
                style={{ minWidth: "17.7%", maxWidth: "17.7%", paddingLeft: "0" }}></td>

            {expandedRowsColumns?.map((col, index) => {
                const colValue = col?.selector(row);
                const spanTitle = col?.hideTitleTooltip || typeof colValue !== "string" ? "" : colValue;

                return (
                    <td
                        className="nested-col-default w-100"
                        key={index}
                        style={{
                            minWidth: col?.minWidth,
                            maxWidth: col?.maxWidth
                        }}>
                        {index === columnActions ? (
                            <CustomColumnActions
                                row={row}
                                isAffiliateEnabled={isAffiliateEnabled}
                                isSuspendEnabled={isSuspendEnabled}
                                isRemoveEnabled={isRemoveEnabled}
                                handleClickAffiliate={handleClickAffiliate}
                                handleClickSuspend={handleClickSuspend}
                                handleClickRemove={handleClickRemove}
                            />
                        ) : (
                            <span title={spanTitle}>{colValue}</span>
                        )}
                    </td>
                );
            })}

            <td
                className="nested-col-default"
                key="nested-col-action"
                style={{ minWidth: "13.33%", maxWidth: "13.33%" }}></td>
        </CustomNestedCols>
    );
};

const InvitationsAvailableColumn = ({
    row,
    isRequestMoreEnabled,
    isCheckStockEnabled,
    handleClickRequestMore,
    handleClickCheckStock
}) => {
    return (
        <div className="flex align-items-center gap-8px">
            {row?.isAllStores ? (
                <FloatingDiv
                    style={{
                        position: "absolute",
                        left: "-12px"
                    }}>
                    All
                </FloatingDiv>
            ) : null}

            <span style={{ width: "46px", flexShrink: 0 }}>
                {row?.invitationsAvailable ?? "--"}/{row?.invitationsAvailable + row?.numberOfFFCs ?? "--"}
            </span>

            <CustomButton
                className={`${isRequestMoreEnabled(row) ? "" : "disabled"}`}
                onClick={() => handleClickRequestMore(row)}>
                Request more
            </CustomButton>

            <CustomButton
                className={`${isCheckStockEnabled(row) ? "" : "disabled"}`}
                onClick={() => handleClickCheckStock(row)}
                style={{ marginLeft: "25px" }}>
                Check stock
            </CustomButton>
        </div>
    );
};

const CustomColumnActions = ({
    row,
    isAffiliateEnabled,
    isSuspendEnabled,
    isRemoveEnabled,
    handleClickAffiliate,
    handleClickSuspend,
    handleClickRemove
}) => {
    return (
        <div className="flex gap-4px">
            <CustomButton
                className={`three-btn-class ${isAffiliateEnabled(row) ? "" : "disabled"}`}
                onClick={() => handleClickAffiliate(row)}>
                Activate
            </CustomButton>
            <CustomButton
                className={`three-btn-class ${isSuspendEnabled(row) ? "" : "disabled"}`}
                onClick={() => handleClickSuspend(row)}>
                Suspend
            </CustomButton>
            <CustomButton
                className={`three-btn-class ${isRemoveEnabled(row) ? "" : "disabled"}`}
                onClick={() => handleClickRemove(row)}>
                Remove
            </CustomButton>
        </div>
    );
};
// #endregion
